/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/function-component-definition */
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

import {
  Grid,
  Box,
  Table,
  TableBody,
  TableContainer,
  TablePagination,
  TableRow,
  TableHead,
  Paper,
  TableCell,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent
} from '@material-ui/core';
import { withStyles, makeStyles, createStyles } from '@material-ui/core/styles';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import DialogContentText from '@material-ui/core/DialogContentText';

import SelectOptions from './SelectOptions';
import PermissionComponent from '../../permissionComponent/PermissionComponent';
import UserRoles from '../../../service/acl/UserRoles';
import './tableContract.css';
import Loading from '../../loading/Loading';
import Button from '../../button/MyButton';
import routing from '../../../service/routes/routing';

const useStyles = makeStyles(theme =>
  createStyles({
    textNotification: {
      textAlign: 'center',
      fontFamily: 'Open Sans',
      fontSize: 14,
      fontWeight: 'bold',
      lineHeight: 'auto',
      color: '#707070',
      '&:hover': {
        backgroundColor: '#41b490',
        color: '#fff',
      },
    },
  }),
);

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: '#005D9F',
    fontFamily: 'Open Sans',
    color: theme.palette.common.white,
  },
  body: {
    color: '#717171',
    fontFamily: 'Open Sans',
  },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    '&:hover': {
      backgroundColor: '#41b490',
      color: '#41b490',
    },
  },
}))(TableRow);

const ContractAwardTableHead = props => {
  const { t } = useTranslation();

  return (
    <TableHead>
      <TableRow>
        <StyledTableCell component="th" style={{ borderTopLeftRadius: '5px' }}>
          {t('contractAwards.table.contractorName')}
        </StyledTableCell>
        <StyledTableCell component="th">
          {t('contractAwards.table.contractorDoc')}
        </StyledTableCell>
        <StyledTableCell component="th">
          {t('contractAwards.table.campaign')}
        </StyledTableCell>
        <StyledTableCell component="th">
          {t('contractAwards.table.contract')}
        </StyledTableCell>
        <StyledTableCell component="th">
          {t('contractAwards.table.awardee')}
        </StyledTableCell>
        <StyledTableCell component="th">
          {t('contractAwards.table.awardeeDoc')}
        </StyledTableCell>
        <StyledTableCell component="th">
          {t('contractAwards.table.email')}
        </StyledTableCell>
        <StyledTableCell component="th">
          {t('contractAwards.table.disabled')}
        </StyledTableCell>
        <StyledTableCell
          component="th"
          align="right"
          style={{ borderTopRightRadius: '5px' }}
        />
      </TableRow>
    </TableHead>
  );
};

export default function ContractAwardTable({
  data,
  page,
  setPage,
  itens,
  setItens,
  chipData,
  setChipData,
  find,
  total,
  disableIndividual,
  onEditAddress,         
}) {
  const { t } = useTranslation();

  const [rows, setRows] = useState([]);
  const [menuOptions, setMenuOptions] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openDisable, setOpenDisable] = useState(false);
  const [loading, setLoading] = useState(false);

  const classes = useStyles();
  const history = useHistory();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setItens(event.target.value);
  };

  const handleMenu = (row, event) => {
    setMenuOptions(row);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpenDisable(false);
  };

  const handleDisable = async () => {
    setLoading(true);
    try {
      await disableIndividual(menuOptions.awardeeDoc, menuOptions.contract, !menuOptions.disabled);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
      handleClose();
    }
  };

const handleEditAddress = () => {
  setAnchorEl(null); 
  if (onEditAddress) {
    onEditAddress(
      {
        doc:  menuOptions.awardeeDoc,
        name: menuOptions.awardee,
        ...menuOptions.all,
      },
      menuOptions.all.id, 
    );
  }
};

  useEffect(() => {
    const listAwards = [];
    data.forEach((li, index) => {
      listAwards.push({
        index,
        id: li.award_id,
        contractorName: li.nome_contratante,
        contractorDoc: li.documento_contratante,
        campaign: li.campanha,
        contract: li.contract_id,
        awardee: li.name,
        awardeeDoc: li.cpf,
        email: li.email,
        disabled: li.disabled,
        all: li,            
      });
    });
    setRows(listAwards);
  }, [data]);

  return (
    <>
      <SelectOptions
        setChipData={setChipData}
        chipData={chipData}
        find={find}
      />
      <Box sx={{ width: '100%' }}>
        <Paper sx={{ width: '100%', mb: 2 }}>
          <TableContainer>
            <Table
              sx={{ minWidth: 750 }}
              aria-labelledby="tableTitle"
              size="medium"
            >
              <ContractAwardTableHead
                rowCount={rows.length}
                handleMenu={handleMenu}
              />
              <TableBody>
                {rows ? (
                  rows.length > 0 ? (
                    rows.map((row) => {
                      return (
                        <StyledTableRow tabIndex={-1} key={row.index}>
                          <StyledTableCell>{row.contractorName}</StyledTableCell>
                          <StyledTableCell>{row.contractorDoc}</StyledTableCell>
                          <StyledTableCell>{row.campaign || '-'}</StyledTableCell>
                          <StyledTableCell>{row.contract}</StyledTableCell>
                          <StyledTableCell>{row.awardee}</StyledTableCell>
                          <StyledTableCell>{row.awardeeDoc}</StyledTableCell>
                          <StyledTableCell>{row.email || '-'}</StyledTableCell>
                          <StyledTableCell>
                            {row.disabled
                              ? t('contractAwards.disabled')
                              : t('contractAwards.active')}
                          </StyledTableCell>
                          <StyledTableCell component="th" align="right">
                            <MoreVertIcon
                              onClick={e => handleMenu(row, e)}
                              fontSize="small"
                              style={{ cursor: 'pointer' }}
                            />
                          </StyledTableCell>
                        </StyledTableRow>
                      );
                    })
                  ) : (
                    <StyledTableRow>
                      <StyledTableCell colSpan={9} align="center">
                        {t('contract.table.notRegistre')}
                      </StyledTableCell>
                    </StyledTableRow>
                  )
                ) : (
                  <StyledTableRow>
                    <StyledTableCell colSpan={9} align="center" />
                  </StyledTableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50, 100, 1000, 50000]}
            component="div"
            count={total}
            rowsPerPage={itens}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
          <Menu
            id="menu-appbar"
            style={{ borderRadius: '25px' }}
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <PermissionComponent role={UserRoles.CONTRACT_DISABLE}>
              <MenuItem
                className={classes.textNotification}
                onClick={handleEditAddress}
              >
                Editar Endereço
              </MenuItem>
            </PermissionComponent>
         
            <PermissionComponent role={UserRoles.CONTRACT_DISABLE}>
              <MenuItem
                className={classes.textNotification}
                onClick={() => {
                  setOpenDisable(true);
                  setAnchorEl(null);
                }}
              >
                {menuOptions?.disabled
                  ? t('contractAwards.table.activate')
                  : t('contractAwards.table.disable')}
              </MenuItem>
            </PermissionComponent>
          </Menu>
        </Paper>
      </Box>
      <Grid
        container
        spacing={1}
        style={{
          justifyContent: 'end',
          padding: 40,
        }}
      />
      <Dialog
        onClose={() => {
          setOpenDisable(!openDisable);
        }}
        open={openDisable}
        fullWidth
        maxWidth="sm"
      >
        <Loading open={loading} msg="Atualizando premiado..." />
        <DialogTitle id="simple-dialog-title">
          {t('contractAwards.dialog.title')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`${menuOptions?.disabled ? t('contractAwards.dialog.bodyMsg2') : t('contractAwards.dialog.bodyMsg1')} ${menuOptions?.awardee}?`}
            <br />
            <br />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <h6
            style={{
              cursor: 'pointer',
              color: '#657588',
              fontWeight: 'bold',
              fontFamily: 'Open Sans',
              marginTop: 5,
            }}
            onClick={() => {
              setOpenDisable(false);
            }}
          >
            {t('contract.dialog.btnCancel')}
          </h6>
          <Button
            style={{ height: 40 }}
            onClick={handleDisable}
            color="primary"
            variant="contained"
            label={t('contract.dialog.btnYes')}
          />
        </DialogActions>
      </Dialog> 
    </>
  );
}
